import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import * as echarts from "echarts";
import "echarts-wordcloud";
import lodash from "lodash";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/assets/styles/reset.scss";
import SklibLayoutVue from "@/components/sklib-layout/index.vue";

Vue.use(ElementUI);
Vue.prototype.$echarts = echarts;
Vue.prototype.$lodash = lodash;

Vue.component("SklibLayoutVue", SklibLayoutVue);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
